// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1NotFoundErrorSchema = z.object({
  errors: z.object({
    message: z.coerce.string().min(1).describe("Error message"),
  }).describe("Error details"),
});
